<app-status-bar></app-status-bar>
<div class="wrapper events-wrapper w-100">
    <div class="events-layout">
        <div class="events-column">
            <!-- Filtros fijos arriba -->
            <div class="filters-bar">
        <div class="searchbar">
            <i class="fal fa-search"></i>
            <input type="text" [value]="searchText" (input)="onSearchChange($any($event.target).value)"
                placeholder="Buscar evento">
        </div>

        <div class="date-filter-wrapper" #fechaDropdown>
            <div class="date-filter-trigger" (click)="openDatePicker=!openDatePicker"
                [class.active]="fromDate">
                <i class="fal fa-calendar"></i>
                <span class="date-label" *ngIf="!stringDate">Fecha</span>
                <span class="date-label" *ngIf="stringDate">{{ stringDate }}</span>
                <i class="fal fa-angle-down arrow-icon"></i>
            </div>
            <div class="calendar-dropdown" *ngIf="openDatePicker">
                <ngb-datepicker class="custom-datepicker-event" #dp [displayMonths]="1" [dayTemplate]="t"
                    outsideDays="visible" (dateSelect)="changeDate($event)" [minDate]="minDate"
                    (navigate)="dateNavigate($event)">
                    <ng-template #t let-date let-focused="focused">
                        <span class="custom-day" [class.focused]="fromDate != null && hoveredDate != null"
                            [class.first-select]="isFromDate(date)" [class.last-select]="isToDate(date)"
                            [class.faded]="isHovered(date) || isInside(date)"
                            [class.border-monday]="isMonday(date)" [class.border-sunday]="isSunday(date)"
                            [class.range]="isRange(date)" [class.day-disabled]="isDisabled(date)"
                            (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                            <span class="inside-day" [class.weekend]="isWeekend(date)">{{ date.day }}</span>
                        </span>
                    </ng-template>
                </ngb-datepicker>
            </div>
        </div>

        <div class="btn-clear-filter" (click)="clearFilters()" *ngIf="searchText || fromDate">
            <i class="fal fa-times"></i>
            <p>Limpiar</p>
        </div>
    </div>

            <!-- Contenido scrollable -->
            <div class="events-main" (scroll)="onScroll($event)">
    <div class="cards-wrapper d-flex justify-content-center">
        <div class="row w-95" style="margin-bottom: 85px ;">
            <div class=" col-3 pb-4" *ngFor="let card of eventCards" (click)="redirectToEvent(card.id)">
                <app-event-card [event]="card"></app-event-card>
            </div>

        </div>
    </div>
    <!-- Spinner de carga para paginación -->
    <div class="loading-spinner" *ngIf="loadingSpinner">
        <mat-progress-spinner color="accent" mode="indeterminate" diameter="40">
        </mat-progress-spinner>
    </div>
            </div><!-- end events-main -->
        </div><!-- end events-column -->
        <div class="events-cart" *ngIf="!reservationId && (cartService.cartStateObs$ | async)?.cart_lines?.length > 0">
            <app-products-resume></app-products-resume>
        </div>
        <div class="events-cart" *ngIf="reservationId">
            <app-reservation-resume [reservationId]="reservationId"></app-reservation-resume>
        </div>
    </div>
</div>